import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { RollingLoader } from '../../../components/commons';
import { returnInputFieldLength } from '../../../utils/commonFunctions';

type AppProps={
    showAddEditClientGroupModal:boolean;
    uniqueClientFetching:boolean;
    isEdit:boolean;
    handleAddClientGroupName:()=>void;
    handleclientGroupNameChange:(data:any)=>void;
    toggleAddEditClientGroupModal:any;
    clientGroupName:string;
    clientGroupNameError:string;
    clientGroupUniqueCheckMessage:string;
}

const AddEditClientGroup = ({
    showAddEditClientGroupModal,
    toggleAddEditClientGroupModal,
    isEdit,
    clientGroupName,
    uniqueClientFetching,
    clientGroupNameError,
    clientGroupUniqueCheckMessage,
    handleAddClientGroupName,
    handleclientGroupNameChange
}:AppProps) => {

    return (
        <Modal isOpen={showAddEditClientGroupModal} toggle={toggleAddEditClientGroupModal}>
            <ModalHeader className="pt-4 pl-4">
                {`${isEdit ? "Edit" : "Add"} Client Group`}
            </ModalHeader>
            <ModalBody className="pl-4 pr-4">
                <form>
                    <div className="form-group mt-3">
                        <div>
                            <label
                                htmlFor="foldername"
                                className={clientGroupName ? "active" : ""}
                            >
                                Enter Client Group Name <span className='color-red'>*</span>
                            </label>
                            <div className="d-flex flex-row position-relative">
                                <input
                                    type="text"
                                    className={`form-control ${!!clientGroupNameError ? "error-border" : null
                                        }`}
                                    name="text"
                                    value={clientGroupName}
                                    autoFocus
                                    onChange={(e) => handleclientGroupNameChange(e)}
                                    maxLength={60}
                                    onKeyPress={(e: any) =>
                                        e.key === "Enter" ? handleAddClientGroupName() : null
                                    }
                                />
                                {uniqueClientFetching && <RollingLoader />}</div>
                            {clientGroupName?.trim().length && clientGroupUniqueCheckMessage?.includes("already exists") ?
                                <small className="text-danger">
                                    Group Name is already in use!
                                </small> : ""
                            }
                            {!!clientGroupNameError && (
                                <small className="text-danger">{clientGroupNameError}</small>
                            )}
                        </div>
                        <span className="input-length">
                            {returnInputFieldLength(clientGroupName?.length, 60)}
                        </span>
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <span className="pointer" onClick={toggleAddEditClientGroupModal}>
                    Cancel
                </span>
                <Button
                    color="primary ml-3"
                    onClick={() => {
                        handleAddClientGroupName();
                        toggleAddEditClientGroupModal();
                    }}
                    disabled={clientGroupName?.trim().length===0 || clientGroupUniqueCheckMessage?.includes("already exists")
                    }
                >
                    {isEdit ? "Update Client Group" : "Add Client Group"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AddEditClientGroup
